module.exports = __webpack_public_path__ + "static/images/notepad.eb5beda12223c6cac392ae17d61ebc86.svg";